import './App.css';

import RmrkForms from './RmrkForms';

function App() {
  return (
    <div className="App">
      <h1>Blockchain Asset Creator (Kusama)</h1>
      <h5>/!\ Beta version - please use at your own risk /!\</h5>
      <div className="vc_row wpb_row vc_row-fluid">
        <RmrkForms />
        <p>(open JS console to check output #F12)</p>
      </div>
    </div>
  );
}

export default App;
